import React from 'react';

import { Chip } from '@material-ui/core';
import { Delete, Lock, SettingsOutlined } from '@material-ui/icons';
import Visibility from '@material-ui/icons/Visibility';
import { Link } from 'react-router-dom';

import { quizCollectionPrivacy } from '../../models/QuizCollection';

const QuizColumns = ({ classes, workspaceName, currentUserName, isMediphanyWorkspace, onDelete }) => {
  return [
    { label: 'Title', name: 'title' },

    {
      label: 'Description',
      name: 'description',
      render: (value) => {
        return <span className={classes.tableDescription}>{value}</span>;
      },
    },

    {
      label: 'Tags',
      name: 'tags',
      render: (_v, data) => {
        return (
          <div className={classes.tableTagsColumnContainer}>
            {(data.tags || []).map((tag) => (
              <Chip key={`${data.id}-tags-${tag}`} className={classes.tableTagsChip} label={tag} size="small" color="primary" />
            ))}
          </div>
        );
      },
    },
    {
      label: 'Privacy Settings',
      name: 'privacy',
      render: (_v, data) => {
        if (data.privacy === quizCollectionPrivacy.GLOBAL) {
          return <span className={classes.tablePrivacyWorkspace}>Mediphany Global</span>;
        }

        if (data.privacy === quizCollectionPrivacy.WORKSPACE) {
          return <span className={classes.tablePrivacyWorkspace}>{workspaceName}</span>;
        }

        return (
          <span className={classes.tablePrivacyUser}>
            <Lock className={classes.tablePrivacyUserIcon} size="small" />
            Private - {currentUserName}
          </span>
        );
      },
    },

    {
      label: '',
      name: 'id',
      render: (_value, data) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'end' }}>
            <Link to={`/quizzes/${data.id}`} className={classes.tableActionColumnContainer}>
              <Visibility className={classes.tableActionIcon} />
              <span>View</span>
            </Link>

            {isMediphanyWorkspace ? (
              <Link to={`/quizzes/${data.id}`} className={classes.tableActionColumnContainer} style={{ marginLeft: '12px' }}>
                <SettingsOutlined className={classes.tableActionIcon} />
                <span>Edit</span>
              </Link>
            ) : null}

            {isMediphanyWorkspace && onDelete ? (
              <div
                className={classes.tableActionColumnContainer}
                style={{ cursor: 'pointer', marginLeft: '12px' }}
                onClick={() => onDelete(data.id, data.title)}
                aria-hidden="true">
                <Delete className={classes.tableActionIcon} />
                <span>Delete</span>
              </div>
            ) : null}
          </div>
        );
      },
    },
  ];
};

export default QuizColumns;
